import { ThemeOptions, createTheme } from '@mui/material';
import merge from 'lodash-es/merge';
import { commanderThemeOptions } from '@upstart/commander-mui-theme';
import '@upstart/commander-mui-theme/variables.css';

export const DeskingTheme = createTheme(
  merge({}, commanderThemeOptions, {
    typography: {
      // Not all components appear to respect this `htmlFontSize` property when extending
      // the `CommanderTheme` with `createTheme(CommanderTheme, {...})`. To work around
      // the issue we can instead create a theme based off the commander theme config
      htmlFontSize: 10,
    },
    components: {
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
          },
        },
      },
    },
    zIndex: {
      modal: 101,
    },
  } as ThemeOptions),
);
